import Vue from "vue";
import App from "./App.vue";
import { MenuEvent } from "./MenuEvent"
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown,faAngleRight,faAngleUp,faSearch,
         faTimes,faPencilAlt,faImage,faBars,} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faAngleDown,faAngleRight,faAngleUp,faSearch,
            faTimes,faPencilAlt,faImage,faBars)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;


if(process.env.NODE_ENV === "production"){
  window.vue_menudata = function(data){
    MenuEvent.$emit("setMenu",data);
  };
  window.vue_menu = function(){
    return new Vue({
      render: h => h(App)
    }).$mount().$el; 
  }
}else{
  var menu = new Vue({
  render: h => h(App)
}).$mount();
MenuEvent.$emit("setMenu",[
  {
    title: "商品を探す",
    item_data: [
      {
        name: "キッチン",
        url: "",
        namae: "kitchen",
        img: "/mizumawari-icon/kitchen.png",
        cate: [
          { name: "1", url: "" ,img:"/image/subcategory/kitchen_31.png"},
          { name: "2", url: "" ,img:"/image/subcategory/kitchen_31.png"},
          { name: "3", url: "" ,img:"/image/subcategory/kitchen_31.png"}
        ]
      },
      {
        name: "バス",
        url: "",
        namae: "bath",
        img: "/mizumawari-icon/bath.png",
        cate: [
          { name: "4", url: "" },
          { name: "5", url: "" },
          { name: "6", url: "" }
        ]
      },
      {
        name: "トイレ",
        url: "",
        namae: "toilet",
        img: "/mizumawari-icon/toilet.png",
        cate: [
          { name: "7", url: "" },
          { name: "8", url: "" },
          { name: "9", url: "" }
        ]
      },
      {
        name: "洗面台",
        url: "",
        namae: "wash",
        img: "/mizumawari-icon/wash.png",
        cate: [
          { name: "10", url: "" },
          { name: "11", url: "" },
          { name: "12", url: "" }
        ]
      }
    ]
  },
  {
    title: "施工実績",
    item_data: [
      { name: "施工例", url: "", icon: "image" },
      { name: "お客様の声", url: "", icon: "pen" }
    ]
  },
  {
    title: "ご利用ガイド",
    item_data: [
      { name: "初めての方へ", url: "#1" },
      { name: "工事までの流れ", url: "#2" },
      { name: "お支払い方法", url: "" },
      { name: "保証について", url: "" },
      { name: "施工エリア", url: "" },
      { name: "よくある質問", url: "" },
      {
        name: "お役立ちコンテンツ",
        url: "",
        namae: "contents",
        cate: [
          { name: "1", url: "" },
          { name: "2", url: "" }
        ]
      },
      {
        name: "会社案内",
        url: "",
        namae: "guide",
        cate: [
          { name: "3", url: "" },
          { name: "4", url: "" }
        ]
      }
    ]
  }
]);
var element = document.getElementById("top-menu")
element.appendChild(menu.$el)
}
